<script>
  let name = '';
  let email = '';
  let message = '';
  let submitStatus = '';
  let statusType = '';
  let isSubmitting = false;

  async function handleSubmit(event) {
    event.preventDefault();
    isSubmitting = true;
    submitStatus = '';

    try {
      const response = await fetch('/.netlify/functions/sendEmail', {
        method: 'POST',
        body: JSON.stringify({ name, email, message }),
      });

      const result = await response.json();

      if (response.ok) {
        submitStatus = 'Message sent successfully!';
        statusType = 'success';
        name = '';
        email = '';
        message = '';
      } else {
        throw new Error(result.message);
      }
    } catch (error) {
      console.error('Error sending email:', error);
      submitStatus = 'Failed to send message. Please try again.';
      statusType = 'error';
    } finally {
      isSubmitting = false;
    }
  }
</script>

<form on:submit={handleSubmit} class="form">
  <div class="field">
    <label class="label" for="name">Name</label>
    <input
      id="name"
      class="input"
      type="text"
      bind:value={name}
      placeholder="Your name"
      required
    />
  </div>

  <div class="field">
    <label class="label" for="email">Email</label>
    <input
      id="email"
      class="input"
      type="email"
      bind:value={email}
      placeholder="you@example.com"
      required
    />
  </div>

  <div class="field">
    <label class="label" for="message">Message</label>
    <textarea
      id="message"
      class="textarea"
      bind:value={message}
      placeholder="Tell us about your project..."
      rows="4"
      required
    ></textarea>
  </div>

  <button
    type="submit"
    class="submit-btn"
    disabled={isSubmitting}
  >
    {#if isSubmitting}
      Sending...
    {:else}
      Send Message
    {/if}
  </button>

  {#if submitStatus}
    <div class="status" class:success={statusType === 'success'} class:error={statusType === 'error'}>
      {submitStatus}
    </div>
  {/if}
</form>

<style>
  .form {
    display: flex;
    flex-direction: column;
    gap: 1.25rem;
  }

  .field {
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
  }

  .label {
    font-size: 0.82rem;
    font-weight: 600;
    color: var(--text-secondary);
    letter-spacing: 0.01em;
  }

  .input, .textarea {
    width: 100%;
    padding: 0.7rem 0.9rem;
    border-radius: var(--radius-sm);
    border: 1px solid var(--border);
    background: rgba(255, 255, 255, 0.04);
    color: var(--text-primary);
    font-family: 'Inter', sans-serif;
    font-size: 0.95rem;
    transition: all 0.2s ease;
    outline: none;
  }

  .input::placeholder, .textarea::placeholder {
    color: var(--text-muted);
  }

  .input:focus, .textarea:focus {
    border-color: var(--accent);
    box-shadow: 0 0 0 3px rgba(129, 140, 248, 0.1);
  }

  .textarea {
    resize: vertical;
    min-height: 100px;
  }

  .submit-btn {
    width: 100%;
    padding: 0.75rem 1.5rem;
    border: none;
    border-radius: var(--radius-sm);
    background: var(--accent-dim);
    color: white;
    font-family: 'Inter', sans-serif;
    font-size: 0.95rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    margin-top: 0.25rem;
  }

  .submit-btn:hover:not(:disabled) {
    background: var(--accent);
    box-shadow: 0 4px 16px rgba(99, 102, 241, 0.25);
  }

  .submit-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  .status {
    padding: 0.65rem 0.9rem;
    border-radius: var(--radius-sm);
    font-size: 0.88rem;
    font-weight: 500;
    text-align: center;
  }

  .status.success {
    background: rgba(34, 197, 94, 0.1);
    color: #4ade80;
    border: 1px solid rgba(34, 197, 94, 0.15);
  }

  .status.error {
    background: rgba(239, 68, 68, 0.1);
    color: #f87171;
    border: 1px solid rgba(239, 68, 68, 0.15);
  }
</style>
